import React from "react";
import { RAIL_SECTIONS } from "../data";
import { useRailSpy } from "../hooks";

export default function Rail() {
  const active = useRailSpy();
  return (
    <div className="rail" aria-hidden="true">
      {RAIL_SECTIONS.map((s, i) => (
        <a
          key={s.id + i}
          href={"#" + s.id}
          className={"rail-dot" + (active === s.id ? " active" : "")}
          data-label={s.label}
        />
      ))}
    </div>
  );
}
